/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('public.case.fillSubCase', {
      url: '/:caseId/subCase/:id/fill',
      template: '<fill-sub-case sub-case="$resolve.subCase"></fill-sub-case>',
      resolve: {
        /* @ngInject */
        subCase: ($http, $stateParams, $state) => $http
          .get(`/public/subCase/${$stateParams.id}/template`, {
            ignoreAuthModule: true,
          })
          .then(({ data }) => data)
          .catch(() => $state.go('four-o-three')),
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/public/case/fillSubCase/fillSubCase.routes.js